import { useState } from 'react'

/**
 * Hook personnalisé pour gérer l'état d'un flyout
 */
export const useFlyout = () => {
  const [isFlyoutVisible, setIsFlyoutVisible] = useState(false)
  const [size, setSize] = useState('l')
  const [sizeName, setSizeName] = useState('large')

  const showFlyout = () => setIsFlyoutVisible(true)
  const closeFlyout = () => setIsFlyoutVisible(false)

  return {
    isFlyoutVisible,
    size,
    sizeName,
    setSize,
    setSizeName,
    showFlyout,
    closeFlyout
  }
}
